/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var PagesIcon = createIcon("PagesIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#FF9F00';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 38v2H7a1 1 0 110-2h41Zm-31.284-9.23a1 1 0 01.221.167l2.126 2.126a1 1 0 01-.222 1.58L11 37l4.356-7.841a1 1 0 011.36-.389Zm10.991-11.063 2.586 2.586a1 1 0 010 1.414l-8.586 8.586a1 1 0 01-1.414 0l-2.586-2.586a1 1 0 010-1.414l8.586-8.586a1 1 0 011.414 0Zm8.716-9.288a2.236 2.236 0 013.158 3.158l-6.894 7.659-.018.019a1 1 0 01-1.414 0l-2.51-2.51a1 1 0 01.038-1.45l7.64-6.876Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.PagesIcon",
  "replaceColor": true
});